export default __webpack_public_path__ + "static/media/shareBlue.3111c1fb.svg";